export enum ParametersEnum {
  windows = 'windows',
  doors = 'doors',
  length = 'length',
  layerThickness = 'layerThickness',
  height = 'height',
  width = 'width',
  area = 'area',
}

export type DoorsWindowsInput = {
  width: string;
  height: string;
};

export type Inputs = {
  doors: string | null;
  windows: string | null;
  width: string | null;
  height: string | null;
  length: string | null;
  layerThickness: string | null;
  thickness: string | null;
  area?: string | null;
  windowsFields: Array<DoorsWindowsInput> | null;
  doorsFields: Array<DoorsWindowsInput> | null;
};

export type FrontendConfigurationTypes = {
  [key: string]: string | number | boolean;
};

export type OmitedInputs = Omit<Inputs, 'windowsFields' | 'doorsFields'>;
